export default __webpack_public_path__ + "static/media/img1.b56f19b0.png";